/* global globalThis */
// Claims identify local ownership; the API still verifies every token and owner.
export const SESSION_CHANGED = 'cad-session-changed';
export const STORAGE_CHANGED = 'cad-pending-changed';

export function readSession(token = localStorage.getItem('rv_token')) {
  try {
    if (!token || token !== localStorage.getItem('rv_token')) return null;
    const profile = JSON.parse(localStorage.getItem('rv_user') || 'null');
    const raw = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const claims = JSON.parse(atob(raw.padEnd(Math.ceil(raw.length / 4) * 4, '=')));
    const ownerUserId = Number(claims.id);
    if (!Number.isSafeInteger(ownerUserId) || ownerUserId <= 0 || Number(profile?.id) !== ownerUserId) return null;
    return { token, ownerUserId, profile, expired: !claims.exp || claims.exp * 1000 <= Date.now() };
  } catch { return null; }
}

export function requireSession(token) {
  const session = readSession(token);
  if (!session) throw new Error('Sign in as the owner before saving this call. Your form has not been sent.');
  return session;
}

export function sessionIsCurrent(session) {
  const current = readSession();
  return current?.ownerUserId === session.ownerUserId && current?.token === session.token;
}

export function operationId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
}

export const emitStorageChange = () => window.dispatchEvent(new Event(STORAGE_CHANGED));
export const emitSessionChange = () => window.dispatchEvent(new Event(SESSION_CHANGED));
